import { PortfolioDashboard } from '@/components/portfolio/PortfolioDashboard';

const Index = () => {
  return <PortfolioDashboard />;
};

export default Index;
